import { Pipe, PipeTransform } from '@angular/core';
import { NO_VALUE } from '@pipes';

const UNKNOWN_MODE = 'unknown';

@Pipe({
  name: 'unknownModeDash',
})
export class UnknownModeDashPipe implements PipeTransform {
  transform(modeName: string): any {
    const modeNameParsed = modeName.toLowerCase();
    if (modeNameParsed === UNKNOWN_MODE || modeNameParsed.endsWith(UNKNOWN_MODE)) {
      return NO_VALUE;
    }

    return modeName;
  }
}
